// extracted by mini-css-extract-plugin
module.exports = {"legal":"report-legal_legal__yJebI","legal__item":"report-legal_legal__item__Otu2t","legal__title":"report-legal_legal__title__Lm_HJ"};